import { connect } from 'react-redux';

import { bindActionCreators } from 'redux';
import { authorizedUser, phonePrefixes } from 'Store/Selectors/AuthSelector';
import * as Types from 'Shared/models/AuthModel';
import { adminLogin, logout } from 'Store/Actions/Auth';
import { changeUserName, deleteCurrentUser, editAvatar, changeUserEmail, getUserExam } from 'Store/Actions/User';
import DashboardHomePage from './Main';
import { getUserExam as getUserExamSelector } from 'Store/Selectors/UserSelector';
import { getDrivingTest } from 'Store/Actions/DrivingTest';

type ConnectedP = {
  phonePrefixes: Array<Types.PhonePrefix>;
  authorizedUser: any | 'init';
  userExam: any;
};

type DispatchedP = {
  actions: {
    adminLogin: ({ email, password }) => (dispatch: any) => Promise<boolean>;
    deleteCurrentUser: () => (dispatch: any) => Promise<boolean>;
    changeUserName: (name: string) => (dispatch: any) => Promise<boolean>;
    changeUserEmail: (email: string) => (dispatch: any) => Promise<boolean>;
    logout: () => (dispatch: any, getState) => Promise<any>;
    editAvatar: (uuid, file, boolean) => void;
    getUserExam: () => any;
    getDrivingTest: () => any;
  };
};
const mapStateToProps = (state) => ({
  phonePrefixes: phonePrefixes(state),
  authorizedUser: authorizedUser(state),
  userExam: getUserExamSelector(state),
});

const mapDispatchToProps = (dispatch): DispatchedP => ({
  actions: bindActionCreators(
    {
      editAvatar: editAvatar,
      adminLogin: adminLogin,
      changeUserName: changeUserName,
      deleteCurrentUser: deleteCurrentUser,
      logout: logout,
      changeUserEmail: changeUserEmail,
      getUserExam: getUserExam,
      getDrivingTest: getDrivingTest,
    },
    dispatch,
  ),
});

export type MainType = ConnectedP & DispatchedP;

export default connect(mapStateToProps, mapDispatchToProps)(DashboardHomePage);
